import { Component, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FormResponse } from 'src/models/form-response';
import { AccountService } from 'src/app/services/account.service';
import { AlertBoxType } from '../base/alert-box/alertboxtype';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent {

  public resetPasswordForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    captcha: new FormControl('')
  });

  public formResponse: FormResponse;

  public alertBoxTypes = AlertBoxType;

  public submitDisabled = false;

  constructor(private accountService: AccountService, private changeDetector: ChangeDetectorRef) { }

  get email() { return this.resetPasswordForm.get('email'); }

  get captcha() { return this.resetPasswordForm.get('captcha'); }

  public submit() {

    if (this.resetPasswordForm.valid) {
      this.submitDisabled = true;
      this.accountService.resetPassword(this.email.value, this.captcha.value).subscribe((result: FormResponse) => {
        this.formResponse = result;

        if (this.formResponse.result === true) {
          this.resetPasswordForm.reset();
        }

        this.submitDisabled = false;

        this.changeDetector.detectChanges();
      });
    } else {
      this.email.markAsDirty();
    }

  }

  public hasErrors() {
    return this.formResponse !== undefined && this.formResponse.errors !== undefined && this.formResponse.errors.length > 0;
  }

}
